export default "__VITE_PUBLIC_ASSET__f516cb2e__"